
import React, {
    useCallback
} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useTranslator } from '@jutro/locale';
import { QuoteCommonMessages } from 'wni-platform-translations';
import { DropdownMenuLink } from '@jutro/router';
import metadata from './BaseAddNewVersionComponent.metadata.json5';

import styles from './BaseAddNewVersionComponent.module.scss';
import messages from './BaseAddNewVersionComponent.messages';



/**
 * Dummy Component provides a blank template  that based on which
 * new component could be created easily
 * @param {object} props
 * @returns {object} React Component
 */
function BaseAddNewVersionComponent(props) {
    const translator = useTranslator();

    const {
        // model: dtoVM,
        // onValueChange,
        // showErrors,
        // sxsDataDTO = {},
        onCreateNewVersion,
        //
        accountJobPeriodDTOList,
        onSwitchToBranch,
        //
        // getMenuItems,
        menuItems,
    } = props;

    // =====================================
    const renderSwitchToOtherBranchMenuItems = useCallback((accountJobPeriodDTOListParam) => {
        const retval =  accountJobPeriodDTOListParam.map((accountJobPeriodDTO) => {
            const {
                publicID: periodPublicID,
                branchName,
                // hoCoverageForm,
            } = accountJobPeriodDTO;

            // const normalizedCoverageForm = hoCoverageForm.toUpperCase();

            // const menuName = `${branchName} ${normalizedCoverageForm}`;
            const menuName = branchName;
            const onMenuClick = async() => onSwitchToBranch(periodPublicID);

            return (
                <DropdownMenuLink
                    type="action"
                    onClick={onMenuClick}
                    key={`${menuName}-MenuLink`}
                >
                    {menuName}
                </DropdownMenuLink>
            );
        });

        return retval;
    }, [onSwitchToBranch]);


    // const writeValue = (value, path) => {
    //     onValueChange(value, path);
    // };
    const renderCreateVersionMenuItems = (menuItemOptions) => {
        const retval =  menuItemOptions.map((menuItem) => {
            const {
                nameMsgKey,
                createService
            } = menuItem;

            const menuName = translator(messages[nameMsgKey]);
            const onMenuClick = async() => onCreateNewVersion(createService);
            
            return (
                <DropdownMenuLink
                    type="action"
                    onClick={onMenuClick}
                    key={`${menuName}-MenuLink`}
                >
                    {menuName}
                </DropdownMenuLink>
            );
        });

        return retval;
    };

    const renderCreateVersionMenuItemsV2 = useCallback(() => {

        // =======================
        const visibleMenuItems =  menuItems.filter((item) => item.menuVisible);

        const retval =  visibleMenuItems.map((menuItem) => {
            const {
                menuName,
                createService,
                menuVisible,
            } = menuItem;

            const onMenuClick = async() => onCreateNewVersion(createService);
            
            return (
                <DropdownMenuLink
                    type="action"
                    onClick={onMenuClick}
                    key={`${menuName}-MenuLink`}
                    visible={menuVisible}
                >
                    {menuName}
                </DropdownMenuLink>
            );
        });

        return retval;
    }, [menuItems, onCreateNewVersion]);

    const getMenuButtonText = useCallback((chooseOptions, addOptions) => {
        let retval = QuoteCommonMessages.addVersions;
        if (!_.isEmpty(chooseOptions)) {
            if (_.isEmpty(addOptions)) {
                retval = QuoteCommonMessages.chooseVersions;
            } else {
                retval = QuoteCommonMessages.chooseAddVersions;
            }
        }

        return retval;
    }, []);

    //----------------------------------
    const createVersionMenuItems = renderCreateVersionMenuItemsV2();
    //
    const switchVersionMenuItems = renderSwitchToOtherBranchMenuItems(accountJobPeriodDTOList);
    const allMenuItems = [...switchVersionMenuItems, ...createVersionMenuItems];
    const menuButtonText = getMenuButtonText(switchVersionMenuItems, createVersionMenuItems);
    

    const overrideProps = {
        '@all': {
        },
        '@field': {
            labelPosition: 'left',
            showOptional: false,
            showRequired: true
        },
        chooseAddNewVersionDropdown: {
            buttonText: menuButtonText,
            disabled: _.isEmpty(allMenuItems),
            content: allMenuItems,
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {

        },
        resolveComponentMap: {

        },
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={{}}
            overrideProps={overrideProps}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            // onModelChange={updateModelValue}
            // resolveValue={readValue}
            // onValueChange={writeValue}
            // showErrors={showErrors}
        />
    );
}

BaseAddNewVersionComponent.propTypes = {
    /**
     * onCreateNewVersion() will be called with the JsonRpc Method as parameter
     */
    onCreateNewVersion: PropTypes.func.isRequired,
    // /**
    //  * (Required) get menu items
    //  */
    // getMenuItems: PropTypes.func.isRequired,
    /**
     * The MenuItem array
     */
    menuItems: PropTypes.arrayOf(PropTypes.shape({
        menuName: PropTypes.string,
        createService: PropTypes.func,
        menuVisible: PropTypes.bool,
    })).isRequired,
    // ====================================
    /**
     * A list of AccountJobPeriodDTO instances
     */
    accountJobPeriodDTOList: PropTypes.arrayOf(PropTypes.shape({})),
    /**
     * Callback to switch to other branch
     */
    onSwitchToBranch: PropTypes.func,
};

BaseAddNewVersionComponent.defaultProps = {
    accountJobPeriodDTOList: [],
    onSwitchToBranch: _.noop,
    // getMenuItems: undefined,
};

export default BaseAddNewVersionComponent;
